module.exports = __webpack_public_path__ + "static/media/SittoStandFemale.8fd86bb9.svg";